import { userContext } from "Context/userContext";
import React, { useCallback } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
// import { getKelurahan } from "services/apiRoutes";

export default function Desa({ onChange, disabled }) {
    const dataContext = useContext(userContext);

    const [kel, setKel] = useState();

    const kelAPI = useCallback(async (e) => {
      // const res = await getKelurahan(e);
      // const { data } = res.data;
      // setKel(data);
    }, []);

    useEffect(() => {
      kelAPI(dataContext.kec);
    }, [kelAPI, dataContext.kec]);

  return (
    <div className="flex flex-col">
      <label htmlFor="kabupaten" className="m-2 text-sm font-semibold">
        Kelurahan / Desa
      </label>
      <select
        // defaultValue={defaultValue}
        // value={setValue}
        disabled={disabled}
        onChange={onChange}
        name="provinsi"
        className="px-3 py-3 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
      >
        {kel?.map((e) => (
          <option key={e.kodeKelurahan} value={e.kodeKelurahan}>
            {e.namaKelurahan}
          </option>
        ))}
      </select>
    </div>
  );
}
